import { render, staticRenderFns } from "./Solicitacoes.vue?vue&type=template&id=13247c7d&"
import script from "./Solicitacoes.vue?vue&type=script&lang=js&"
export * from "./Solicitacoes.vue?vue&type=script&lang=js&"
import style0 from "./Solicitacoes.vue?vue&type=style&index=0&id=13247c7d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports